import React from "react";
import { Label, Icon } from "semantic-ui-react";

interface IUnreadCommentsTagProps {
  count: number;
  onClick?: () => void;
}

const UnreadCommentsTag = ({ count, onClick }: IUnreadCommentsTagProps) => {
  return <Label
    style={{ cursor: onClick ? "pointer" : "auto" }}
    onClick={e => {
      e.preventDefault();
      onClick && onClick();
    }}
  >
    <Icon name='mail' />{count}
  </Label >
}

export default UnreadCommentsTag;